
import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";
import Modal from "@/views/modal/Modal.vue";
import ScrollPaginationMixin from "@/mixins/Pagination.mixin";
import { mixins } from "vue-class-component";
import { OPERATOR_TYPE } from "@/constant";
import { ModelListSelect } from "vue-search-select";

@Component({ components: { Modal, ModelListSelect } })
export default class ListRoleComponent extends mixins(ScrollPaginationMixin) {
  public showModal = false;
  public operatorTypes = OPERATOR_TYPE;
  public operator = {};
  public operators = [];
  public isOperatorListEmpty = true;
  public operatorType = null;
  public apis = [];

  public refresh() {
    this.operatorType = null;
    this.searchString = null;
    this.paginationConfig.currentPage = 1;
    this.getOperatorList();
  }

  public onSearchString() {
    this.paginationConfig.currentPage = 1;
    this.getOperatorList();
  }

  action(operatorId, operatorType, actionName) {
    this.operators.forEach((operator) => {
      if (operator._id == operatorId) {
        operator.editable = actionName == "edit" ? true : false;
        operator.showError = false;
      } else {
        operator.editable = false;
        operator.showError = false;
      }
    });
    this.operators = JSON.parse(JSON.stringify(this.operators));
    this.getAPIOperatorCodeListByOperatorType(operatorType);
  }

  public onPageChange(page) {
    this.paginationConfig.currentPage = page;
    this.getOperatorList();
  }

  public onChangeOperatorType() {
    this.paginationConfig.currentPage = 1;
    this.getOperatorList();
  }

  public updateAPISwitching(operatorId) {
    let operator = this.operators.find((a) => a._id == operatorId);
    console.log("1111 ",operator,operatorId)
    if (operator.operatorType == "DMT") {
      // let operatorCodes = this.operators.filter((a) => a.operatorType == "DMT");
      // console.log("2222 ",operatorCodes)
      // let companyNameofDMT = [];
      // operatorCodes.forEach((o) => {
      //   let api = this.apis.find(
      //     (a) =>
      //       a.operatorType == "DMT" &&
      //       o.activeAPIOperatorCodeId &&
      //       a._id == o.activeAPIOperatorCodeId
      //   );
      //   if (api) companyNameofDMT.push(api.apiReference);
      // });
      // if (this.$lodash.uniq(companyNameofDMT).length > 1) {
      //   console.log(companyNameofDMT)
      //   this.$snotify.info(
      //     "Every DMT APi switching must be belong to same company."
      //   );
      //   this.enableError(operatorId);
      // } else this.updateOperator(operatorId);
      this.updateOperator(operatorId);
    } else this.updateOperator(operatorId);
  }

  public async updateOperator(operatorId) {
      let operator = this.operators.find((a) => a._id == operatorId);
      if (operator.activeAPIOperatorCodeId) {
        let result = await Axios.post(
          API_STORE.ADMIN + "updateOperator",
          {
            operatorId: operator._id,
            activeAPIOperatorCodeId: operator.activeAPIOperatorCodeId,
            active: operator.active,
          },
          {
            headers: getAPIAuthorizedHeader(),
          }
        );
        this.$snotify.success(result.data.message);
        if(result) this.getOperatorList();
      } else {
        this.enableError(operatorId);
      }
  }

  public async getAPIOperatorCodeListByOperatorType(operatorType) {
      let response = await Axios.get(
        API_STORE.ADMIN + "getAPIOperatorCodeListByOperatorType",
        {
          params: {
            operatorType: operatorType,
            subdomain: this.$client ? this.$client.subdomain : null,
          },
          headers: getAPIAuthorizedHeader(),
        }
      );
      if(response) this.apis = response.data;
  }

  public enableError(operatorId) {
    this.operators.forEach((operator) => {
      if (operator._id == operatorId) operator.showError = true;
    });
    this.operators = JSON.parse(JSON.stringify(this.operators));
  }

  public async getOperatorList() {
      this.asyncPageLoader = true;
      let obj = {
        searchString: this.searchString,
        limit: this.paginationConfig.pageLimit,
        page: this.paginationConfig.currentPage,
        operatorType: this.operatorType,
      };
      let response = await Axios.get(API_STORE.ADMIN + "getOperatorList", {
        params: obj,
        headers: getAPIAuthorizedHeader(),
      });
      this.asyncPageLoader = false;
      if (response && response.data && response.data.docs) {
        this.paginationConfig.totalPages = response.data.totalPages;
        this.paginationConfig.totalLength = response.data.totalDocs;
        this.operators = response.data.docs.map((a) => {
          a["editable"] = false;
          a["showError"] = false;
          return a;
        });
        this.operators = JSON.parse(JSON.stringify(this.operators));
        if (this.operators.length > 0 && this.counter == 0) {
          this.counter++;
          this.isOperatorListEmpty = false;
        }
      }
  }

  mounted() {
    this.getOperatorList();
  }
}
